module.exports = __webpack_public_path__ + "img/dashboard-header-image@2x.eea7d15c.png";